import {
  FETCH_GAMES_FAILURE,
  FETCH_GAMES_REQUEST,
  FETCH_GAMES_SUCCESS,
  SET_FOCUSED_POSITION
} from '../actions/games'

const INITIAL_STATE = {
  isReady: false,
  isFetching: false,
  hasError: false,
  errorMessage: '',
  lastUpdated: -1,
  focusedPosition: 0,
  games: []
}

const gamesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_GAMES_REQUEST:
      return {
        ...state,
        isFetching: true,
        hasError: false,
        errorMessage: ''
      }
    case FETCH_GAMES_SUCCESS:
      return {
        ...state,
        isReady: true,
        isFetching: false,
        lastUpdated: Date.now(),
        currentIndex: 0,
        interval: action.payload.interval,
        games: action.payload.games.map(game => ({
          id: +game.app_id,
          name: game.app_name,
          thumb: game.app_thumb_url,
          img: game.app_bg_url,
          url: game.app_url,
          desc: game.app_description
        }))
      }
    case FETCH_GAMES_FAILURE:
      return {
        ...state,
        isReady: true,
        isFetching: false,
        hasError: true,
        errorMessage: action.payload.message,
        lastUpdated: Date.now()
      }

    case SET_FOCUSED_POSITION:
      return {
        ...state,
        focusedPosition: action.payload.position
      }

    default:
      return state
  }
}

export default gamesReducer
